<template>
  <tr>
    <td>
      <code>{{ name }}</code>
    </td>
    <td>
      <small class="tag">{{ type }}</small>
    </td>
    <td>
      <code>{{ def }}</code>
    </td>
    <td>
      <code v-if="comp">{{ comp }}</code>
    </td>
  </tr>
</template>

<script>
export default {
  name: "SassVariablesTableEntry",
  props: {
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    def: {
      type: String,
      required: true
    },
    comp: {
      type: String,
      required: false
    }
  }
};
</script>

<style lang="css"></style>
